import { useFormContext } from "react-hook-form";
import { ErrorMessage, RadioInput, Typography } from "@/components/atoms";
import { useSiteConfig } from "@/hooks";
import { clsx } from "@/utils";
import { AddTransferTypeFormData, FIXED_TRIP_TYPES } from "../form";

export const TransferTypeTripTypeField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const { isMultiTenant } = useSiteConfig();
  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext<AddTransferTypeFormData>();

  const handleTripTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (FIXED_TRIP_TYPES.includes(value)) {
      setValue("isAdminOnly", true);
    } else {
      setValue("isAdminOnly", false);
    }
  };

  return (
    <div className={clsx("flex flex-col gap-y-5", className)} {...props}>
      <Typography variant="action">Select Trip Type</Typography>
      <div className="flex space-x-8">
        <RadioInput label="Standard" value="journey_rate" {...register("tripType", { onChange: handleTripTypeChange })} />
        <RadioInput label="Hourly" value="hourly_rate" {...register("tripType", { onChange: handleTripTypeChange })} />
        <RadioInput label="Daily" value="daily_rate" {...register("tripType", { onChange: handleTripTypeChange })} />
        <RadioInput label="Fixed" value="fixed_rate" {...register("tripType", { onChange: handleTripTypeChange })} />
        {!isMultiTenant && <RadioInput label="Fixed International" value="fixed_rate_international" {...register("tripType", { onChange: handleTripTypeChange })} />}
      </div>
      <ErrorMessage errors={errors} name="name" />
    </div>
  );
};
